export default __webpack_public_path__ + "static/media/799.bd4fb1a7.png";